var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-container",
        [
          _c("el-header", [_c("el-row", [_vm._v("更换手机号码")])], 1),
          _vm._v(" "),
          _c(
            "el-main",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18, offset: 3 } },
                    [
                      _c(
                        "el-steps",
                        {
                          attrs: {
                            space: 250,
                            active: _vm.active,
                            "align-center": ""
                          }
                        },
                        [
                          _c("el-step", { attrs: { title: "身份验证" } }),
                          _vm._v(" "),
                          _c("el-step", { attrs: { title: "更换手机号码" } }),
                          _vm._v(" "),
                          _c("el-step", { attrs: { title: "完成" } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.active == 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { staticClass: "mar-top-30" },
                        [
                          _c("el-col", { attrs: { span: 8, offset: 9 } }, [
                            _c("span", [
                              _vm._v("已绑定的手机号码：" + _vm._s(_vm.phone))
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "mar-top-30" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "flex-row-plus",
                              attrs: { span: 5, offset: 8 }
                            },
                            [
                              _c("el-input", {
                                staticClass: "codeipt",
                                attrs: { placeholder: "验证码" },
                                model: {
                                  value: _vm.verifyCode,
                                  callback: function($$v) {
                                    _vm.verifyCode = $$v
                                  },
                                  expression: "verifyCode"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticClass: "flex-row-plus",
                              attrs: { span: 3 }
                            },
                            [
                              _vm.isoldCodeShow
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "codebut",
                                      on: { click: _vm.getoldCode }
                                    },
                                    [_vm._v(_vm._s(_vm.oldcodeText))]
                                  )
                                : _c("el-button", { staticClass: "codebut" }, [
                                    _vm._v(_vm._s(_vm.oldcodeText))
                                  ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "mar-top-30" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "flex-row-plus",
                              attrs: { span: 4, offset: 10 }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "submitBut",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.checkUser }
                                },
                                [_vm._v("下一步")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.active == 1
                ? _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { staticClass: "mar-top-30" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8, offset: 8 } },
                            [
                              _c("el-input", {
                                staticClass: "codeipt",
                                attrs: {
                                  type: "number",
                                  placeholder: "输入新号码"
                                },
                                model: {
                                  value: _vm.iphoneNum,
                                  callback: function($$v) {
                                    _vm.iphoneNum = $$v
                                  },
                                  expression: "iphoneNum"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "mar-top-30" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "flex-row-plus",
                              attrs: { span: 5, offset: 8 }
                            },
                            [
                              _c("el-input", {
                                staticClass: "codeipt",
                                attrs: {
                                  type: "number",
                                  placeholder: "验证码"
                                },
                                model: {
                                  value: _vm.code,
                                  callback: function($$v) {
                                    _vm.code = $$v
                                  },
                                  expression: "code"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticClass: "flex-row-plus",
                              attrs: { span: 3 }
                            },
                            [
                              _vm.isCodeShow
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "codebut",
                                      on: {
                                        click: function($event) {
                                          return _vm.getCode(1)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.codeText))]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "codebut",
                                      attrs: { type: "primary" }
                                    },
                                    [_vm._v(_vm._s(_vm.codeText))]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "mar-top-30" },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "flex-row-plus",
                              attrs: { span: 4, offset: 10 }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    { name: "throttle", rawName: "v-throttle" }
                                  ],
                                  staticClass: "submitBut",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.updatePhone }
                                },
                                [_vm._v("提交")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.active == 2
                ? _c(
                    "div",
                    { staticStyle: { margin: "70px 0" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "margin-bottom": "20px"
                              },
                              attrs: { span: 8, offset: 8 }
                            },
                            [
                              _c("img", {
                                staticClass: "finishImg",
                                attrs: {
                                  src: require("../../../../static/image/wancheng@2x.png")
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: 8, offset: 8 }
                            },
                            [_c("span", [_vm._v("恭喜您，更换手机已完成！")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticClass: "mar-top-50" },
            [
              _c("el-row", { staticClass: "flex-column-plus mar-20-30" }, [
                _c("span", { staticClass: "fs8" }, [_vm._v("安全服务提示")]),
                _vm._v(" "),
                _c("span", { staticClass: "mar-top-20 fs7 font-color-9A9" }, [
                  _vm._v("•\n          绑定手机可提高帐号安全性")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mar-top-10 fs7 font-color-9A9" }, [
                  _vm._v("• 一个手机号只能绑定一个帐号")
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2237e45c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2237e45c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/changeInfo/changePhone.vue
// module id = null
// module chunks = 